

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L from 'leaflet';
import * as esri from 'esri-leaflet';
import { SavedFilter } from '@/models/SavedFilter';
import EmbeddedLeafletMap from '@/components/EmbeddedLeafletMap.vue';

@Component({
    components: {
        EmbeddedLeafletMap,
    },
})
export default class FilterManager extends Vue {

    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 415;
    public showDialog: boolean = false;
    public showMap: boolean = false;
    public selectedGeoJson: any = null; // Leaflet types are messed up, will be Feature<Polygon | MultiPolygon, any> | null
    public selectedName: string = '';

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initFilters') {
            this.initFilters();
        }
        if (action.type === 'showFilterManager') {
            this.onShowDialog();
        }
        if (action.type === 'hideFilterManager') {
            this.onCloseDialog();
        }
    });

    get map(): L.Map {
        return this.$store.state.map;
    }

    get config() {
        return this.$store.state.config;
    }

    get isLoggedIn(): boolean {
        return this.$store.state.isLoggedIn;
    }

    get savedFilters(): SavedFilter[] {
        if (this.$store.state.filters.savedFilters.length === 0) {
            this.showDialog = false;
        }
        return this.$store.state.filters.savedFilters;
    }

    get isLoading(): boolean {
        return this.$store.state.filters.isFilterLoading;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    get mapWidth(): string {
        if (!this.isMobile) {
            return '550';
        } else {
            return (this.$q.screen.width * 0.7).toFixed(0);
        }
    }

    get mapHeight(): string {
        if (!this.isMobile) {
            return '300';
        } else {
            return '500';
        }
    }

    get previewMobileDialogStyle(): string {
        return 'height: ' + (this.$q.screen.height - 10) + 'px; width: ' + (this.$q.screen.width - 10) + 'px;';
    }

    public onShowDialog() {
        this.showMap = false;
        this.showDialog = true;
    }

    public onCloseDialog() {
        this.showDialog = false;
    }

    public initFilters() {
        this.$store.dispatch('getFilterData');

        // TODO not sure why this is needed...
        this.pingSchoolsService();
    }

    public onRestoreFilter(mfid: number) {
        console.log('FilterManager: onRestoreFilter()');
        this.$store.dispatch('restoreFilter', mfid);
    }

    public onDeleteFilter(mfid: number) {
        console.log('FilterManager: onDeleteFilter()');
        this.$store.dispatch('removeSavedFilter', mfid);
    }

    public onFilterAreaClick(filter: SavedFilter) {
        console.log('FilterManager: onFilterAreaClick()');
        if (this.showMap) {
            // this will destroy component if it was previously created so it can be mounted/initalized again
            this.showMap = false;
            setTimeout(() => {
                this.selectedGeoJson = filter.getGeoJson();
                this.selectedName = filter.Name;
                this.showMap = true;
            }, 50);
        } else {
            this.selectedGeoJson = filter.getGeoJson();
            this.selectedName = filter.Name;
            this.showMap = true;
        }
        const dialogElement = document.getElementById('filterManagerDialog');
        if (dialogElement) {
            dialogElement.scrollTo(0, 0);
        }
    }


    public pingSchoolsService() {
        const pingSchools = esri.query({
            url: this.config.SchoolCatchmentLayer.url,
            proxy: this.config.proxy.url,
        });
        pingSchools.where('1=1').count((error) => {
            if (!error) {
                // Logger.writeLog("_pingSchoolsService..success");
                console.log('_pingSchoolsService..success');
            } else {
                // Logger.writeLog("_pingSchoolsService..failed");
                console.log('_pingSchoolsService..failed');
            }
        });
    }

}

